// ! import all of the widget functions

import { accordian } from "../../widgets/accordian/src/widget";
import { customFooter } from "../../widgets/custom-footer/src/widget";
import { customNavigation } from "../../widgets/custom-navigation/src/widget";
import { homeHero } from "../../widgets/home-hero/src/widget";
import { onThisPage } from "../../widgets/on-this-page/src/widget";
import { tabs } from "../../widgets/tabs/src/widget";
import { menuMaker } from "../../widgets/menu-maker/src/widget";

// ------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function() { 

    // ! Call all of the widget scripts here.
    menuMaker()
    customNavigation()
    homeHero()

    tabs()
    accordian()

    customFooter()
    onThisPage()
    
});
